// File: src/components/potus/TruthSocialPosts.jsx
import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import TitleAndInfo from '../TitleAndInfo';
import TruthSocialCard from './TruthSocialCard';

const TruthSocialPosts = ({ data, loading }) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" my={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
    
      <Box sx={{ mb: 3, pl: 2, display: "flex", alignItems: "center" }}>
        {/* Truth Social Logo 
        <Box
          sx={{
            width: 28,
            height: 28,
            backgroundColor: '#5448ee',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 2
          }}
        >
          <Typography 
            variant="body1" 
            sx={{ 
              color: 'white', 
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            T
          </Typography>
        </Box>
        */}
        
        <TitleAndInfo
          titleTop="Truth Social Posts:"
          title=""
          info="Latest posts from President Trump's Truth Social account."
        />
      </Box>

      {!data || data.length === 0 ? (
        <Typography variant="body1" align="center" p={2}>
          No Truth Social posts available.
        </Typography>
      ) : (
        <Box>
          {data.map((post, index) => (
            <TruthSocialCard 
              key={post.unique_id || index} 
              post={post} 
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default TruthSocialPosts;